import axiosInstance from "../../utils/axios";

export const fetchMyAccount = async (id) => {
  const res = await axiosInstance.get("/api/user/profile", {
    withCredentials: true,
  });
  return res;
};

export const updateMyAccount = async (user) => {
  const formDataFiles = new FormData();
  formDataFiles.append("avatar", user.avatar);
  delete user.avatar;
  formDataFiles.append("user", JSON.stringify(user));

  const res = await axiosInstance.post(
    `/api/user/profile/update`,
    formDataFiles,
    {
      headers: formDataFiles.getHeaders,
      withCredentials: true,
    }
  );
  return res;
};
